export default "__VITE_ASSET__DILGmP1c__"